module.exports = __webpack_public_path__ + "img/medicne_economy.mars.09887b5.png";